import layout from '@/layout'

export default {
  path: '/manage',
  component: layout,
  redirect: '/manage/schedule',
  name: 'manage',
  meta: {
    title: '排班管理',
    icon: 'manage'
  },
  children: [
    {
      path: '/manage/schedule',
      name: 'manageSchedule',
      component: () => import('@/views/manage/schedule'),
      meta: {
        title: '门店排班',
        icon: 'manage'
      }
    }
  ]
}
